import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export interface ClienteIntegracao {
  id: number; codigo: string; nome: string; tipo: string;
  permite_execucao_manual: boolean; agendamento_ativo: boolean;
  cron_expressao: string | null; fuso_horario: string; proxima_execucao_em: string | null;
  ultima_execucao_guid: string | null; ultimo_status: string | null;
  ultima_execucao_inicio: string | null; ultima_execucao_fim: string | null;
}
export interface ClienteExecucao {
  id: number; execucao_guid: string; chamada_nome: string; origem: string;
  status: string; solicitado_em: string; hr_inicial: string | null; hr_final: string | null;
  totalitens: number | null; total_atualizados: number | null; total_sem_alteracao: number | null;
  total_zerados: number | null; total_nao_encontrados: number | null; total_invalidos: number | null;
  tentativa: number; chamadas_api: number; log_status: string | null;
}
export interface ClienteExecucaoPagina { page: number; pageSize: number; items: ClienteExecucao[]; }

@Injectable({ providedIn: 'root' })
export class ClienteIntegracoesService {
  private readonly base: string;
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.base = baseUrl.replace(/\/$/, '') + '/api/ClienteIntegracoes';
  }
  private headers(): HttpHeaders { return new HttpHeaders({ 'X-Cliente-Integracoes-Token': localStorage.getItem('cliente_integracoes_token') || '' }); }
  listar(): Observable<ClienteIntegracao[]> { return this.http.get<ClienteIntegracao[]>(this.base + '/integracoes', { headers: this.headers() }); }
  executar(id: number, requestId: string, numeroNf?: number, codigoProduto?: number): Observable<{ execucaoGuid: string; status: string; reutilizada: boolean }> {
    return this.http.post<{ execucaoGuid: string; status: string; reutilizada: boolean }>(this.base + `/integracoes/${id}/execucoes`, { requestId, numeroNf, codigoProduto }, { headers: this.headers() });
  }
  historico(pagina: number, status: string, inicio: string, fim: string, clienteIntegracaoId: number | null = null): Observable<ClienteExecucaoPagina> {
    let params = new HttpParams().set('pagina', pagina.toString()).set('tamanho', '50');
    if (clienteIntegracaoId !== null) params = params.set('clienteIntegracaoId', clienteIntegracaoId.toString());
    if (status) params = params.set('status', status);
    if (inicio) params = params.set('inicio', inicio);
    if (fim) params = params.set('fim', fim);
    return this.http.get<ClienteExecucaoPagina>(this.base + '/execucoes', { params, headers: this.headers() });
  }
  detalhe(id: string): Observable<ClienteExecucao> { return this.http.get<ClienteExecucao>(this.base + `/execucoes/${encodeURIComponent(id)}`, { headers: this.headers() }); }
  static permitido(): boolean {
    return ['true', '1'].includes(localStorage.getItem('flag_gerencia_permissoes') || '')
      && ['N', 'T'].includes(localStorage.getItem('flag_menu_integracoes'));
  }
  static mensagem(error: HttpErrorResponse): string {
    if (error.status === 401) return 'Sua sessão de integrações expirou. Saia e entre novamente no portal.';
    if (error.status === 403) return 'Seu usuário não possui permissão para acessar as integrações.';
    return error.error?.mensagem || error.error?.title || 'Não foi possível consultar a central de integrações. Tente novamente.';
  }
  static status(value: string | null): string {
    const labels: { [key: string]: string } = { PENDENTE: 'Na fila', EM_EXECUCAO: 'Em execução', AGUARDANDO_RETENTATIVA: 'Aguardando nova tentativa',
      SUCESSO: 'Concluída', SUCESSO_COM_ALERTA: 'Concluída com alerta', ERRO: 'Falha', CANCELADO: 'Cancelada' };
    return value ? labels[value] || value : 'Ainda não executada';
  }
}
